<template>
	<v-card flat color="transparent">
		<v-card-title primary-title>
			<h2 class="font-weight-bold">{{ outlets.length }} Outlets</h2>
		</v-card-title>
		<v-card-text>
			<v-container grid-list-md class="pa-0">
				<v-layout row wrap>
					<v-flex
						class="d-flex flex-column"
						xs12
						md4
						v-for="(outlet, index) in outlets"
						:key="index"
					>
						<ShopOutletCard
							:outlet="outlet"
							:type="type"
						></ShopOutletCard>
					</v-flex>
				</v-layout>
			</v-container>
		</v-card-text>
	</v-card>
</template>

<script>
import ShopOutletCard from "./ShopOutletCard.vue";
export default {
	components: {
		ShopOutletCard,
	},
	props: ["outlets", "type"],
};
</script>
